/**
 * Sesión Django para mantenedores Estudyoo (actividades + juegos).
 * Token compartido con Sync Django.
 */
import store from '@/store';
import { loginDjango as loginDjangoSync, setDjangoSyncToken, getDjangoSyncToken } from '@/services/DjangoSyncService';

const SS_EMAIL = 'estudyoo_admin_django_email';
const SS_PASS = 'estudyoo_admin_django_password';

export function estudyooBackendConfigured() {
  return !!(process.env.VUE_APP_BACK_URL || '').replace(/\/$/, '');
}

export function getDjangoAdminToken() {
  return getDjangoSyncToken();
}

export function isDjangoAdminAuthenticated() {
  return !!getDjangoAdminToken();
}

export function persistDjangoCredentials(email, password) {
  if (email) sessionStorage.setItem(SS_EMAIL, email.trim().toLowerCase());
  if (password) sessionStorage.setItem(SS_PASS, password);
}

export async function loginDjangoAdmin(username, password) {
  const data = await loginDjangoSync(username, password);
  persistDjangoCredentials(username, password);
  store.commit('auth/setDjangoToken', data.access_token);
  return data;
}

/** Tras login Google: intenta Django si hay credenciales guardadas o se pasan. */
export async function loginDjangoInBackground(email, password) {
  if (!estudyooBackendConfigured()) return { ok: true, skipped: true };
  const user = (email || sessionStorage.getItem(SS_EMAIL) || '').trim();
  const pass = password || sessionStorage.getItem(SS_PASS) || '';
  if (!user || !pass) return { ok: false, skipped: true, needPassword: true };
  try {
    await loginDjangoAdmin(user, pass);
    return { ok: true };
  } catch (e) {
    console.warn('[Django admin] login en segundo plano:', e?.response?.data || e.message);
    return { ok: false, error: e };
  }
}

export function clearDjangoAdminSession() {
  setDjangoSyncToken('');
  sessionStorage.removeItem(SS_EMAIL);
  sessionStorage.removeItem(SS_PASS);
  store.commit('auth/setDjangoToken', null);
}

/** Maneja 401 del API Django (token ausente, expirado o inválido). */
export function handleDjangoApiError(error, { toast, onUnauthorized } = {}) {
  if (error?.response?.status !== 401) return false;
  clearDjangoAdminSession();
  onUnauthorized?.();
  toast?.add({
    severity: 'warn',
    summary: 'Sesión Django',
    detail: 'Token inválido o expirado. Conecta de nuevo con usuario staff en el panel superior.',
    life: 7000,
  });
  return true;
}
